import React from "react";
import { useTheme } from "@mui/material/styles";
import styled from "@emotion/styled";
import UMMOConfig from "config";

function ProductDescription() {
  const theme = useTheme();
  return (
    <div
      style={{
        backgroundColor: theme.palette.blackish.main,
        color: theme.palette.primary.contrastText,
      }}
    >
      <PaddedDiv>
        <UMMOHeading>{UMMOConfig.text.UMMOHeading}</UMMOHeading>
        <UMMODescription>{UMMOConfig.text.UMMODescription}</UMMODescription>
      </PaddedDiv>
    </div>
  );
}

const PaddedDiv = styled.div`
  padding: 0.5rem min(8vw, 5rem) 1.25rem;
`;
const UMMOHeading = styled.h1`
  font-weight: bold;
  font-size: 3.125rem;
`;

const UMMODescription = styled.p`
  font-weight: 300;
  font-size: 1.625rem;
`;

export default ProductDescription;
